import type { ReactNode } from 'react';
import { Card } from '@savvy-kit/components/card';
import { Text } from '@savvy-kit/foundations/text';

import { HouseholdAvatar } from './household-avatar';

export function ContactWebLegend() {
  return (
    <Card size="sm" className="flex-row items-center gap-3 rounded-lg px-3 py-2 shadow-sm">
      <LegendItem icon={<HouseholdAvatar size="xs" />} label="Household" />
      <LegendItem icon={<div className="size-4 rounded-full bg-muted ring-2 ring-savvy-gold/70" />} label="Contact" />
    </Card>
  );
}

function LegendItem({ icon, label }: { readonly icon: ReactNode; readonly label: string }) {
  return (
    <div className="flex items-center gap-1.5">
      {icon}
      <Text variant="caption" color="secondary">
        {label}
      </Text>
    </div>
  );
}
